import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d726e31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { class: "d-flex align-start" }
const _hoisted_4 = { class: "d-flex justify-space-between align-end" }
const _hoisted_5 = {
  key: 1,
  class: "value"
}

import { withDefaults, watch, defineAsyncComponent, ref } from 'vue';
import { AtomInfoCard, AtomToogleButton, AtomSubTitle, MoreHorizontalIcon, LoaderIcon } from '@/components/atoms';
import * as comps from '@/components/atoms';
import { formatLang, formatNumber } from '@/utils/formatNumber'

import { IItemDiagnostic } from '@/types';
import AtomButton from '../atoms/AtomButton.vue';
interface IProps {
  itemDiagnostic: IItemDiagnostic
  loading?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeDiagnostic',
  props: {
    itemDiagnostic: null,
    loading: { type: Boolean }
  },
  emits: ['handleToggle', 'clickMore'],
  setup(__props: any, { emit }) {

const props = __props as { itemDiagnostic: IItemDiagnostic, loading?: boolean };




function handleCLickMore() {
  emit('clickMore')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "area-icon me-2 pa-1",
          style: _normalizeStyle({ backgroundColor: props.itemDiagnostic.color })
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.itemDiagnostic.icon]), {
            color: props.itemDiagnostic.iconColor
          }, null, 8, ["color"]))
        ], 4),
        _createVNode(_unref(AtomSubTitle), {
          "no-margin": "",
          text: props.itemDiagnostic.item,
          class: "title-card"
        }, null, 8, ["text"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (props.loading)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon)), {
            key: 0,
            class: "ma-auto"
          }))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.itemDiagnostic.value), 1)),
      (!props.loading && props.itemDiagnostic.nFloat)
        ? (_openBlock(), _createBlock(comps.AtomBadge, {
            key: 2,
            color: "#000000",
            bgColor: "#DCDCDC",
            text: props.itemDiagnostic.nFloat,
            class: "percent"
          }, {
            icon: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(props.itemDiagnostic.isPositive ? comps.ArrowUpIcon : comps.ArrowDownIcon), { color: "#868E96" }))
            ]),
            _: 1
          }, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})